import { PERMISSION_ACTIONS } from './permissionActions';
import { PERMISSION_SUBJECTS } from './permissionSubjects';

const SUPER_BATCH_MANAGEMENT_SIDEBAR_DATA = [
  {
    header: 'SUPER BATCH MANAGEMENT',
    tabs: [
      {
        tabName: 'META UPDATES',
        to: '/super-batch-management/update-meta/',
        subject: PERMISSION_SUBJECTS.superBatch,
        permissions: [
          PERMISSION_ACTIONS.manage,
          PERMISSION_ACTIONS.read,
          PERMISSION_ACTIONS.update,
        ],
      },
    ],
  },
];

export default SUPER_BATCH_MANAGEMENT_SIDEBAR_DATA;
